// eslint-disable-next-line import/no-extraneous-dependencies
import Node from '@ckeditor/ckeditor5-engine/src/model/node';
import { useDraggable } from '@dnd-kit/core';
import { CSS } from '@dnd-kit/utilities';
import { useId } from 'react';

interface DraggableProps {
  node: Node;
  children: JSX.Element;
  disabled: boolean;
  isDragging: boolean;
}

export function Draggable({ node, children, disabled, isDragging }: DraggableProps) {
  const id = useId();
  const { attributes, listeners, setNodeRef, transform, setActivatorNodeRef } = useDraggable({
    id,
    data: {
      node,
    },
    disabled,
  });

  return (
    <div
      ref={setNodeRef}
      style={{
        transform: CSS.Translate.toString(transform),
        position: 'static',
        display: 'flex',
      }}
      className={isDragging ? 'is-dragging' : ''}
    >
      {!disabled && (
        <div>
          <div ref={setActivatorNodeRef} className="drag-handle" {...attributes} {...listeners}>
            <svg viewBox="0 0 20 20" width="12">
              <path
                fill="gray"
                d="M7 2a2 2 0 1 0 .001 4.001A2 2 0 0 0 7 2zm0 6a2 2 0 1 0 .001 4.001A2 2 0 0 0 7 8zm0 6a2 2 0 1 0 .001 4.001A2 2 0 0 0 7 14zm6-8a2 2 0 1 0-.001-4.001A2 2 0 0 0 13 6zm0 2a2 2 0 1 0 .001 4.001A2 2 0 0 0 13 8zm0 6a2 2 0 1 0 .001 4.001A2 2 0 0 0 13 14z"
              />
            </svg>
          </div>
        </div>
      )}
      {children}
    </div>
  );
}
